"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rx = require("rxjs");
const cache_1 = require("./cache");
const keautils_1 = require("keautils");
function observeResource(func, ...arg) {
    const reFunc = func;
    if (reFunc.bindedResource == null || reFunc.bindedResource.createObservable == null) {
        throw new Error("La función no forma parte de un resource que tenga bind");
    }
    return reFunc.bindedResource.createObservable(func, ...arg);
}
exports.observeResource = observeResource;
function observeResourceNoMemo(func, ...arg) {
    /**
     * El observe debe de llamar al thunk en la primera subscripcion y con cada nueva subscripción, y con cada invalidación siempre y cuando existan subscriptores.
     * La función NO se debe de llamar la crear el observable
     */
    const reFunc = func;
    if (reFunc.bindedResource == null)
        throw new Error("La función no forma parte de un resource que tenga bind");
    let subscriptionCount = 0;
    let firstSubscription = true;
    const subject = new rx.Subject();
    const obs = subject.concatAll();
    let errorFlag = false;
    async function onInvalidateHandler() {
        if (subscriptionCount > 0) {
            const prom = func(...arg);
            subject.next(keautils_1.toObservable(prom));
            await prom;
        }
    }
    cache_1.addOnInvalidateHandler(reFunc.bindedResource, onInvalidateHandler);
    return new rx.Observable(subscriber => {
        Promise.resolve(func(...arg)).then(x => subscriber.next(x), error => {
            errorFlag = true;
            subscriber.error(error);
        });
        const sub = obs.subscribe(subscriber);
        const ret = new rx.Subscription(() => {
            sub.unsubscribe();
            subscriptionCount--;
        });
        subscriptionCount++;
        firstSubscription = false;
        return ret;
    });
}
exports.observeResourceNoMemo = observeResourceNoMemo;
//# sourceMappingURL=observe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/cache/observe.js
// module id = 516
// module chunks = 0